import React, { useState, useRef } from 'react';
import './slider.css';
import moment from 'moment';

const Slider = ({ t, dates, dateSelected }) => {
  const left = 'left';
  const right = 'right';
  const [active, setActive] = useState(0);
  const scrollRef = useRef(null);

  const onDateClick = (date, index) => {
    setActive(index);
    dateSelected(date);
  };

  const slideSlots = (e) => {
    const slider = scrollRef.current;
    const { scrollWidth } = slider;
    const clientW = slider.clientWidth;
    const maxW = clientW - scrollWidth;
    if (e === right) {
      slider.scrollLeft += 140;
    } else if (e === left) {
      slider.scrollLeft -= 140;
    }
  };


  return (
    <div className="slider__wrapper">
      <button className="slider__btn slider__left" onClick={() => slideSlots(left)}></button>
      <div className="slider__content" ref={scrollRef}>
        {
          dates.map((cur, index) => (
            <div key={index} className={["slider__card", index === active && "active"].join(' ')} onClick={() => onDateClick(cur.date, index)}>
              <p>{moment(cur.date, 'DD-MM-YYYY').format('ddd, MMM DD')}</p>
              <span>{cur.available_slot_count} {t('SLOTS_AVAILABLE')}</span>
            </div>
          ))

        }

      </div>

      <button className="slider__btn slider__right" onClick={() => slideSlots(right)}></button>
    </div>

  );
};

export default Slider;
